import "jquery-ujs";
import "bootstrap/js/dist/tab";

// Define the <copy-code-button> custom element so copy-to-clipboard works on the
// docs code blocks rendered by the shared CodeBlock. The define guard makes this
// idempotent, so registering it once app-wide is enough.
import "../../../docs/components/copyCodeButton.client";

// Timezone setting
import moment from "moment-timezone";

export const setTimezone = (timezone: string) => {
  moment.tz.setDefault(timezone);
};

import React from "react";
import { createRoot } from "react-dom/client";

// Core components that can render the page
import App from "frame/App";
import Page from "frame/Page";
import ApiExplorer from "features/ApiExplorer/ApiExplorer";

// Top-level React components
import AccountSettings from "features/Account/AccountSettings";
import GoogleSignIn from "features/Account/GoogleSignIn";
import Login from "features/Account/Login";
import Signup from "features/Account/Signup";
import MarketplaceLink from "features/Billing/MarketplaceLink";
import DoorkeeperAuthorization from "features/Account/DoorkeeperAuthorization";

const topLevelComponents = {
  AccountSettings,
  GoogleSignIn,
  Login,
  Signup,
  MarketplaceLink,
  DoorkeeperAuthorization,
};

export const renderTopLevelComponent = (
  graphqlUri: string,
  id: string,
  name: string,
  props: { [key: string]: any },
) => {
  const container = document.getElementById(id);
  if (container) {
    const root = createRoot(container);
    const TopLevelComponent =
      topLevelComponents[name as keyof typeof topLevelComponents];
    root.render(
      <App graphqlUri={graphqlUri}>
        {React.createElement(
          TopLevelComponent as any /* TODO: type safety for props */,
          props,
        )}
      </App>,
    );
  }
};

export const renderPageComponent = (
  graphqlUri: string,
  id: string,
  props: { [key: string]: any },
) => {
  const container = document.getElementById(id);
  if (container) {
    const root = createRoot(container);
    root.render(
      <App graphqlUri={graphqlUri}>
        <Page {...props} />
      </App>,
    );
  }
};

export const renderApiExplorer = (graphqlUri: string, id: string) => {
  const container = document.getElementById(id);
  if (container) {
    const root = createRoot(container);
    root.render(<ApiExplorer graphqlUri={graphqlUri} />);
  }
};
